// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginForm_overlay__HbKrC {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.LoginForm_modal__gUCrb {
  background-color: #1a1a1a;
  padding: 24px;
  width: 100%;
  max-width: 400px;
  background-color: #ededed;
  color: #000000;
  font-family: 'Montserrat', sans-serif;
}

.LoginForm_header__sRNgF {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
  position: relative;
}

.LoginForm_header__sRNgF h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  flex-grow: 1;
  text-align: left;
}

.LoginForm_backButton__DDXmW {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
}

.LoginForm_backButton__DDXmW:hover {
  opacity: 0.7;
}

.LoginForm_closeButton__acfGJ {
  background: none;
  border: none;
  font-size: 32px;
  width: 48px;
  height: 48px;
  line-height: 1;
  padding: 8px;
  cursor: pointer;
  color: #000000;
  font-weight: 300;
  transition: opacity 0.2s ease;
}

.LoginForm_closeButton__acfGJ:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.LoginForm_emailForm__FjFrY {
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  margin-bottom: 24px;
}

.LoginForm_emailInput__pJyjC {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid silver;
  color: white;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
}

.LoginForm_emailInput__pJyjC:focus {
  outline: none;
  border-color: #007bff;
}

.LoginForm_submitButton__bbAle {
  width: 48px;
  background-color: black;
  color: white;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
}

.LoginForm_submitButton__bbAle:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.LoginForm_verificationContent__N03Wf {
  text-align: center;
  padding: 20px 0;
}

.LoginForm_emailIcon__RhpLF {
  width: 64px;
  height: 64px;
  background-color: #000000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.LoginForm_icon__O7ny2 {
  width: 32px;
  height: 32px;
  color: white;
}

.LoginForm_verificationText__dJTqe {
  margin-bottom: 16px;
  line-height: 1.5;
  color: #000000;
}

.LoginForm_verificationInstruction__QZga3 {
  margin-bottom: 32px;
  color: #666666;
  font-size: 14px;
  line-height: 1.5;
}

.LoginForm_emailDisplay__sDnmu {
  color: #000000;
  font-weight: 600;
}

.LoginForm_codeInputs__18F2k {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 24px;
}

.LoginForm_codeInput__2UK9X {
  width: 40px;
  height: 40px;
  background-color: #2a2a2a;
  border: 1px solid #333;
  border-radius: 8px;
  color: white;
  font-size: 1.2rem;
  text-align: center;
  font-family: 'Montserrat', monospace;
}

.LoginForm_codeInput__2UK9X:focus {
  outline: none;
  border-color: #007bff;
}

.LoginForm_resendButton__CxX6y {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0;
}

.LoginForm_resendButton__CxX6y:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.LoginForm_divider__JYT2K {
  text-align: center;
  position: relative;
  margin: 24px 0;
}

.LoginForm_divider__JYT2K::before,
.LoginForm_divider__JYT2K::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 45%;
  height: 1px;
  background-color: silver;
}

.LoginForm_divider__JYT2K::before {
  left: 0;
}

.LoginForm_divider__JYT2K::after {
  right: 0;
}

.LoginForm_divider__JYT2K span {
  padding: 0 10px;
  color: silver;
  font-size: 14px;
}

.LoginForm_walletButton__goZBd {
  width: 100%;
  padding: 12px;
  background-color: #ffffff;
  border: none;
  border-radius: 8px;
  color: #000000;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.LoginForm_walletButton__goZBd:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.LoginForm_walletIcon__gQhai {
  width: 24px;
  height: 24px;
}

.LoginForm_terms__p8N5C {
  text-align: center;
  font-size: 0.8rem;
  color: #666;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
}

.LoginForm_link__55zuQ {
  color: #007bff;
  text-decoration: none;
}

.LoginForm_link__55zuQ:hover {
  text-decoration: underline;
}

.LoginForm_loadingSpinner__m2xiZ {
  width: 20px;
  height: 20px;
  animation: LoginForm_spin__RincR 1s linear infinite;
  margin-left: 8px;
}

.LoginForm_spinnerPath__Bm175 {
  stroke: currentColor;
  stroke-linecap: round;
  animation: LoginForm_dash__x\\+lrv 1.5s ease-in-out infinite;
}

@keyframes LoginForm_spin__RincR {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes LoginForm_dash__x\\+lrv {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dappPages/components/Login/LoginForm.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mDAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,2DAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background-color: #1a1a1a;\n  padding: 24px;\n  width: 100%;\n  max-width: 400px;\n  background-color: #ededed;\n  color: #000000;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 24px;\n  position: relative;\n}\n\n.header h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: 'Montserrat', sans-serif;\n  flex-grow: 1;\n  text-align: left;\n}\n\n.backButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.2s ease;\n}\n\n.backButton:hover {\n  opacity: 0.7;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 32px;\n  width: 48px;\n  height: 48px;\n  line-height: 1;\n  padding: 8px;\n  cursor: pointer;\n  color: #000000;\n  font-weight: 300;\n  transition: opacity 0.2s ease;\n}\n\n.closeButton:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.emailForm {\n  display: flex;\n  justify-content: space-between;\n  align-items: space-between;\n  margin-bottom: 24px;\n}\n\n.emailInput {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid silver;\n  color: white;\n  font-size: 1rem;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.emailInput:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.submitButton {\n  width: 48px;\n  background-color: black;\n  color: white;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.submitButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.verificationContent {\n  text-align: center;\n  padding: 20px 0;\n}\n\n.emailIcon {\n  width: 64px;\n  height: 64px;\n  background-color: #000000;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px;\n}\n\n.icon {\n  width: 32px;\n  height: 32px;\n  color: white;\n}\n\n.verificationText {\n  margin-bottom: 16px;\n  line-height: 1.5;\n  color: #000000;\n}\n\n.verificationInstruction {\n  margin-bottom: 32px;\n  color: #666666;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.emailDisplay {\n  color: #000000;\n  font-weight: 600;\n}\n\n.codeInputs {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.codeInput {\n  width: 40px;\n  height: 40px;\n  background-color: #2a2a2a;\n  border: 1px solid #333;\n  border-radius: 8px;\n  color: white;\n  font-size: 1.2rem;\n  text-align: center;\n  font-family: 'Montserrat', monospace;\n}\n\n.codeInput:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.resendButton {\n  background: none;\n  border: none;\n  color: #007bff;\n  cursor: pointer;\n  font-size: 0.9rem;\n  padding: 0;\n}\n\n.resendButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.divider {\n  text-align: center;\n  position: relative;\n  margin: 24px 0;\n}\n\n.divider::before,\n.divider::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  width: 45%;\n  height: 1px;\n  background-color: silver;\n}\n\n.divider::before {\n  left: 0;\n}\n\n.divider::after {\n  right: 0;\n}\n\n.divider span {\n  padding: 0 10px;\n  color: silver;\n  font-size: 14px;\n}\n\n.walletButton {\n  width: 100%;\n  padding: 12px;\n  background-color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  color: #000000;\n  font-size: 1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.walletButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.walletIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.terms {\n  text-align: center;\n  font-size: 0.8rem;\n  color: #666;\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.link {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.link:hover {\n  text-decoration: underline;\n}\n\n.loadingSpinner {\n  width: 20px;\n  height: 20px;\n  animation: spin 1s linear infinite;\n  margin-left: 8px;\n}\n\n.spinnerPath {\n  stroke: currentColor;\n  stroke-linecap: round;\n  animation: dash 1.5s ease-in-out infinite;\n}\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `LoginForm_overlay__HbKrC`,
	"modal": `LoginForm_modal__gUCrb`,
	"header": `LoginForm_header__sRNgF`,
	"backButton": `LoginForm_backButton__DDXmW`,
	"closeButton": `LoginForm_closeButton__acfGJ`,
	"emailForm": `LoginForm_emailForm__FjFrY`,
	"emailInput": `LoginForm_emailInput__pJyjC`,
	"submitButton": `LoginForm_submitButton__bbAle`,
	"verificationContent": `LoginForm_verificationContent__N03Wf`,
	"emailIcon": `LoginForm_emailIcon__RhpLF`,
	"icon": `LoginForm_icon__O7ny2`,
	"verificationText": `LoginForm_verificationText__dJTqe`,
	"verificationInstruction": `LoginForm_verificationInstruction__QZga3`,
	"emailDisplay": `LoginForm_emailDisplay__sDnmu`,
	"codeInputs": `LoginForm_codeInputs__18F2k`,
	"codeInput": `LoginForm_codeInput__2UK9X`,
	"resendButton": `LoginForm_resendButton__CxX6y`,
	"divider": `LoginForm_divider__JYT2K`,
	"walletButton": `LoginForm_walletButton__goZBd`,
	"walletIcon": `LoginForm_walletIcon__gQhai`,
	"terms": `LoginForm_terms__p8N5C`,
	"link": `LoginForm_link__55zuQ`,
	"loadingSpinner": `LoginForm_loadingSpinner__m2xiZ`,
	"spin": `LoginForm_spin__RincR`,
	"spinnerPath": `LoginForm_spinnerPath__Bm175`,
	"dash": `LoginForm_dash__x+lrv`
};
export default ___CSS_LOADER_EXPORT___;
